enum ActionType {
    Login = 'LOGIN',
    Logout = 'LOGOUT',
}

export default ActionType;
